import { render, staticRenderFns } from "./ShowSaldo.vue?vue&type=template&id=060ae5bd&scoped=true&"
import script from "./ShowSaldo.vue?vue&type=script&lang=js&"
export * from "./ShowSaldo.vue?vue&type=script&lang=js&"
import style0 from "./ShowSaldo.vue?vue&type=style&index=0&id=060ae5bd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060ae5bd",
  null
  
)

export default component.exports